import React from 'react';
import { Switch, BrowserRouter, Redirect, Route } from 'react-router-dom';
import MainPage from '../views/Main';
import Login from '../views/Login';
import Device from '../views/Device';
import TermsOfService from '../views/TermsOfService';

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Redirect exact from="/" to="/login" />
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/device">
          <Device />
        </Route>
        <Route path="/admin">
          <MainPage />
        </Route>
        <Route path="/terms-of-service">
          <TermsOfService />
        </Route>
        <Route path="*">
          <h2>Not Found</h2>
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

export default Router;
